import React from "react";
import { useLocation } from "react-router-dom";
import {
  Avatar,
  Box,
  Button,
  Container,
  CssBaseline,
  Typography,
} from "@material-ui/core";
import MailOutlineIcon from "@material-ui/icons/MailOutline";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  root: {
    minHeight: "100vh",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    padding: theme.spacing(4, 2),
  },
  content: {
    width: "100%",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    textAlign: "center",
  },
  avatar: {
    margin: theme.spacing(1),
    backgroundColor: theme.palette.secondary.main,
  },
  spaceAfter: {
    marginBottom: 15,
  },
  button: {
    marginTop: theme.spacing(3),
  },
}));

export const NotInvited = () => {
  const classes = useStyles();
  const location = useLocation();
  const email = location.state && location.state.email;

  return (
    <Box className={classes.root} component="main">
      <CssBaseline />
      <Container maxWidth="xs">
        <div className={classes.content}>
          <Avatar className={classes.avatar}>
            <MailOutlineIcon />
          </Avatar>
          <Typography component="h1" variant="h5" className={classes.spaceAfter}>
            You haven't been invited yet
          </Typography>
          <Typography variant="body1" color="textSecondary">
            {email
              ? `We couldn't find an account for ${email} on any team.`
              : "We couldn't find an account for you on any team."}
          </Typography>
          <Typography variant="body1" color="textSecondary" className={classes.spaceAfter}>
            To use PlanPraise, ask your team's administrator or leader to send
            you an invitation link, then try signing in again.
          </Typography>
          <Button
            className={classes.button}
            variant="contained"
            color="primary"
            href="/login"
          >
            Back to sign in
          </Button>
        </div>
      </Container>
    </Box>
  );
};

export default NotInvited;
